import {
    BMI_ID,
    CMS_ID,
    FEET_ID,
    LBS_ID,
} from '../components/prescriptionPad/rightPanel/workspace/padV2/VitalTable';
import {
    cmsToMeter,
    lbsToKgs,
} from '../components/prescriptionPad/rightPanel/workspace/padV2/growthChart/constants/utils';
import { SERVER_VITALS } from '../components/prescriptionPad/leftPanel/vitals';
import { VitalsEntity } from '../store/types/prescription';

export const fillBMI = ({
    weight,
    height,
    weightUnit,
    heightUnit,
}: {
    weight: string;
    height: string;
    weightUnit: string;
    heightUnit: string;
}): VitalsEntity | undefined => {
    let weightValue;
    let heightValue;
    let BMI;

    const weightVitalUnitId = weightUnit;

    if (weightVitalUnitId === LBS_ID) {
        weightValue = lbsToKgs(parseFloat(weight)).toString();
    } else {
        weightValue = weight;
    }

    // Height Vital should be from MDB to check unit (cms/feet)

    const heightVitalUnitId = heightUnit;

    if (heightVitalUnitId === CMS_ID) {
        heightValue = cmsToMeter(parseFloat(height)).toString();
    }
    if (heightVitalUnitId === FEET_ID) {
        const heightInFeet = height.split("'");
        heightValue = (
            parseFloat(String(heightInFeet[0])) + (parseFloat(String(heightInFeet[1])) / 12 || 0)
        ).toString();
    }

    if (
        weightValue &&
        !isNaN(parseFloat(weightValue)) &&
        heightValue &&
        !isNaN(parseFloat(heightValue))
    ) {
        BMI = parseFloat(weightValue) / (parseFloat(heightValue) * parseFloat(heightValue));

        const bmiVital = SERVER_VITALS.find((v) => v.id === BMI_ID);

        if (!bmiVital) {
            return;
        }

        return {
            name: bmiVital?.name || '',
            dis_name: bmiVital?.dis_name || '',
            id: bmiVital?.id || '',
            value: {
                qt: BMI.toFixed(1) || '',
                unit: bmiVital.units_with_ranges[0].dis_unit,
                safe: bmiVital.units_with_ranges[0].safe,
            },
            interpretation: undefined,
            isoDate: new Date().toISOString(),
            remark: undefined,
        };
    }
};
